/**
 * Program view component.
 * @module components/theme/View/ProgramView
 */

import React from 'react';

import ProgramHero from './components/ProgramHero';
import ProgramEpisodes from './components/ProgramEpisodes';
import ProgramAbout from './components/ProgramAbout';
import ProgramSchedule from './components/ProgramSchedule';
import ProgramViewProgramsCarousel from './components/ProgramViewProgramsCarousel';

import UploadBannerSection from '../../../shared/UploadBannerSection/UploadBannerSection';

import bannerParticipe from '../../../../theme/assets/images/banner-participe.png';
import bannerPremio from '../../../../theme/assets/images/banner-premio.png';

import './ProgramView.less';

type Props = {
  content?: any;
};

function resolveProgramImage(content: any): string | undefined {
  return (
    content?.image?.scales?.teaser?.download ||
    content?.image?.scales?.large?.download ||
    content?.image?.download
  );
}

export default function ProgramView({ content }: Props) {
  const title = content?.title || '';
  const heroImage = resolveProgramImage(content);
  const programPath = content?.['@id'] || '';

  return (
    <section className="program-view">
      <div className="program-view__top">
        <div className="program-view__main">
          <ProgramHero content={content} imageUrl={heroImage} />
          <ProgramEpisodes
            programPath={programPath}
            parentTitle={title}
            parentImage={heroImage}
          />
        </div>

        <div className="program-view__container-aside">
          <div className="program-view__aside">
            <ProgramAbout content={content} />
            <ProgramSchedule schedule={content?.schedule} />
          </div>

          <UploadBannerSection
            imageUrl={bannerParticipe}
            imageWidth={440}
            imageHeight={233}
            data={{
              imageAlt: 'Banner Participe da Rádio MEC',
              href: '/participe',
              title: 'Participe da Rádio MEC',
              linkAriaLabel: 'Acessar página Participe da Rádio MEC',
            }}
          />
        </div>
      </div>

      <div className="program-view__bottom">
        <ProgramViewProgramsCarousel />
        <UploadBannerSection
          imageUrl={bannerPremio}
          imageWidth={369}
          imageHeight={392}
          data={{
            imageAlt: '',
            href: '/programas/premio-radio-mec',
            title: 'Ir para página do Prêmio da Rádio MEC',
            linkAriaLabel: 'Acessar página do Prêmio da Rádio MEC',
          }}
        />
      </div>
    </section>
  );
}
